import { render, staticRenderFns } from "./TaskErrorDetailsModal.vue?vue&type=template&id=70fb2739&scoped=true&"
import script from "./TaskErrorDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./TaskErrorDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb2739",
  null
  
)

export default component.exports